const CALCOMID = 110013;
const CALCOM_EVENT_TYPE = 380687;
const CALCOM_SCHEDULE_ID = 112350;
const CALCOM_NAME = "YiMing";

type Time = { time: string }; // ISO String
type Slots = {
  slots: Record<string, Time[]>;
};

export async function getSlots() {
  const startTime = new Date();

  console.log(startTime.toISOString());
  let endTime = new Date(startTime.getTime() + 7 * 24 * 60 * 60 * 1000);

  // If Thursday or Friday, skip the weekend
  const dayOfWeek = startTime.getDay(); // 0 = Sunday, 4 = Thursday, 5 = Friday
  if (dayOfWeek === 4) {
    // Thursday
    endTime = new Date(startTime.getTime() + 9 * 24 * 60 * 60 * 1000); // Skip to Monday
  } else if (dayOfWeek === 5) {
    // Friday
    endTime = new Date(startTime.getTime() + 8 * 24 * 60 * 60 * 1000); // Skip to Monday
  }

  console.log(endTime.toISOString());

  const url =
    `https://api.cal.com/v1/slots?apiKey=${"cal_live_4fa05a58b59b4489f6d67d6f312737de"}` +
    // const url = `https://api.cal.com/v1/slots?apiKey=${env.CAL_API_KEY ?? "cal_live_4fa05a58b59b4489f6d67d6f312737de"}` +
    `&startTime=${encodeURIComponent(startTime.toISOString())}` +
    `&endTime=${encodeURIComponent(endTime.toISOString())}` +
    `&timeZone=America/Toronto` +
    `&eventTypeId=${CALCOM_EVENT_TYPE}`;

  const options = { method: "GET", body: undefined };

  try {
    const response = await fetch(url, options);
    const data = (await response.json()) as Slots;
    console.log("data", JSON.stringify(data));

    const formattedData = Object.entries(data.slots).map(([date, slots]) => {
      // Parse date in Toronto timezone to avoid day shift
      const dateObj = new Date(date + "T00:00:00-04:00"); // Toronto timezone offset
      return {
        date: dateObj.toLocaleDateString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          timeZone: "America/Toronto",
        }),
        times: slots.map((slot) =>
          new Date(slot.time).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
            timeZone: "America/Toronto",
          })
        ),
      };
    });

    return formattedData;
  } catch (error) {
    console.error(error);
  }
}

export async function createNewBooking({
  start,
  email,
}: {
  start: Date;
  email: string;
}) {
  console.log("createNewBooking", start, email);

  const url =
    "https://api.cal.com/v1/bookings?apiKey=" +
    "cal_live_4fa05a58b59b4489f6d67d6f312737de";
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      eventTypeId: CALCOM_EVENT_TYPE,
      start: start.toISOString(),
      end: new Date(start.getTime() + 15 * 60000).toISOString(),
      responses: {
        name: CALCOM_NAME,
        email: email,
        location: { value: "userPhone", optionValue: "" },
      },
      timeZone: "America/Toronto",
      language: "en",
      title: "Cal Setter Demo",
      description: null,
      status: "PENDING",
      metadata: {},
    }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    console.log(data);
    if (!response.ok) {
      // @ts-ignore
      throw new Error(data.message);
    }
    return data as {
      uid: string;
      attendees: [
        id: number,
        email: string,
        name: string,
        timeZone: string,
        phoneNumber: string | null,
        locale: string,
        bookingId: number,
        noShow: boolean,
      ];
      references: Array<{
        type: string;
        uid: string;
        thirdPartyRecurringEventId: string | null;
        meetingId: string;
        meetingPassword: string;
        meetingUrl: string;
        externalCalendarId: string;
        credentialId: number;
      }>;
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
}
